export const EXPERIMENT_PAGE_TEST = 'pageTest' as const;
export const EXPERIMENT_PAGE_TEST_ORIGINAL = 'original' as const;
export const EXPERIMENT_PAGE_TEST_VARIATION = 'variation' as const;
